import React, { useEffect } from 'react';
import { Form, Col, Row, Card, Tag } from 'antd';
import form, { FormInstance } from 'antd/lib/form';
import HeroTitle from 'components/theme_components/HeroTitle';
import Title from 'antd/lib/typography/Title';
import {
  CheckOutlined,
  ArrowRightOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import DualPieChart from '../../../../../../components/theme_components/PieChart';
import ModalSFS from '../../../../../../components/theme_components/ModalSFS';
import AddresseModal from './AddresseModal';
import { deleteThirdPartyAddress, TpAddressResponse2 } from 'services/thirdParty';
import { useForm } from 'antd/lib/form/Form';
import Notification from 'components/theme_components/Notifications';

export type AddressCardProps = {
  address: TpAddressResponse2;
  tpid: number
  refetch?: () => void;
  onDone: any;

};

const AddressCard = ({ address, tpid, refetch, onDone }: AddressCardProps) => {
  const [form] = useForm();
  const done = () => {
    onDone();
    // form.submit();
  };
  const fieldName = 'listAdresses';
  useEffect(() => {
    if (address) {
      form.setFieldsValue({ [fieldName]: address });
    } else {
      form.setFieldsValue({ [fieldName]: [] });
    }
  }, [form, address]);

  return (
    <Form form={form}>
      <Row gutter={[16, 16]} justify="center" className="ml-0 mr-0">
        <Col span={24}>
          <Card className="activity-card mt-20">
            <Row gutter={[16, 16]} className="ml-0 mr-0">
              <Col span={20}>
                {' '}
                <Title level={2}>{address.adrtypelabel} </Title>
              </Col>
              <Col span={2}>
                {!(address.adrtype == "MAIN" || address.adrtype == "SIEGE") && <DeleteOutlined className="color-orange font-size-25" onClick={() => {
                  deleteThirdPartyAddress({
                    tpadrid: address.tpadrid,
                    tpid: address.tpid,
                  }).then((res) => {
                    Notification({
                      status: "success",
                      message: res.message,
                      description: res.description,
                      duration: 30,
                      placement: 'topRight',
                      confirm: true
                    });
                    refetch && refetch();

                  });
                }} />}
              </Col>
              <Col span={2}>
                {' '}
                <ModalSFS
                  trigger={({ setVisible }) => (
                    <EditOutlined
                      className="color-orange font-size-25 floatRight"
                      onClick={() => setVisible(true)}
                    />
                  )}
                  title="Modification d'adresse"
                >
                  <AddresseModal
                    tpid={tpid}
                    address={address}
                    disableType={address.adrtype === 'MAIN' } 
                    setVisible={() => false}
                    refetch={refetch} onDone={done} />
                </ModalSFS>
              </Col>
              <Col span={2} className="align-content-center gray-color">
                {' '}
                <EnvironmentOutlined className="font-size-30 align-center" />
              </Col>
              <Col span={22}>
                <div className="align-center">
                  <p className="font-size-18 "> {address.tpmainadrstreet1} </p>
                  <p className="font-size-18 ">
                    {' '}
                    {address.tpmainadrzipcode} {address.tpmainadrcitylabel}{' - '}{address.tpmainadrcountrylabel}{' '}
                  </p>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};

export default AddressCard;
